var map = {
	"./crud": "./src/option/crud/index.js",
	"./crud/": "./src/option/crud/index.js",
	"./crud/index": "./src/option/crud/index.js",
	"./crud/index.js": "./src/option/crud/index.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/option sync recursive ^\\.\\/.*$";